import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, StatusCodeActive, StatusCodeDelete, TransactionTypeOptions } from "utils/Constant"
import { ApiDeleteTransaction, ApiGetDailySessionList, ApiGetTransactionById, ApiGetVehicleBrandList, ApiGetVehicleColorList, ApiUpdateTransaction } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { GetStatus, money, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker"
import Dropdown from "components/Input/Dropdown"

export default function SalesFormModal({ isOpen, onClose, formType, transactionId, locationId }) {
    const navigate = useNavigate()

    const { fetch: apiGetTransactionById } = useFetch(ApiGetTransactionById)
    const { fetch: apiDeleteTransaction } = useFetch(ApiDeleteTransaction)
    const { fetch: apiGetVehicleBrand } = useFetch(ApiGetVehicleBrandList)
    const { fetch: apiGetVehicleColor } = useFetch(ApiGetVehicleColorList)
    const { fetch: apiGetDailySession } = useFetch(ApiGetDailySessionList)
    const { fetch: apiUpdateTransaction } = useFetch(ApiUpdateTransaction)

    let queryString = new URLSearchParams(window.location.search)

    const [selectedTransactionalDate, setSelectedTransactionalDate] = useState({})
    const [transactionalDateOptions, setTransactionalDateOptions] = useState([])
    const [dailySessionId, setDailySessionId] = useState('')
    const [transactionDate, setTransactionDate] = useState(null)
    const [transactionalDate, setTransactionalDate] = useState(null)
    const [clockIn, setClockIn] = useState(null)
    const [clockOut, setClockOut] = useState(null)
    const [employeeIn, setEmployeeIn] = useState('')
    const [employeeOut, setEmployeeOut] = useState('')
    const [plateNumber, setPlateNumber] = useState('')
    const [locationName, setLocationName] = useState('')
    const [tarrif, setTarrif] = useState('')
    const [vehicleBrandOptions, setVehicleBrandOptions] = useState([])
    const [vehicleBrandId, setVehicleBrandId] = useState('')
    const [vehicleBrand, setVehicleBrand] = useState('')
    const [vehicleColorOptions, setVehicleColorOptions] = useState([])
    const [vehicleColorId, setVehicleColorId] = useState('')
    const [vehicleColor, setVehicleColor] = useState('')
    const [vehicleModel, setVehicleModel] = useState('')
    const [currentFormType, setCurrentFormType] = useState(formType)
    const [transactionType, setTransactionType] = useState('')
    const [transactionTypeText, setTransactionTypeText] = useState('')

    const [customerCard, setCustomerCard] = useState(EmptyString)
    const [customerCardOptions, setCustomerCardOptions] = useState([])
    const [edcData, setEdcData] = useState([])
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const customerCardOnInput = (e) => {
        // fGetCustomerCardList(e)
    }
    const customerCardChange = (e) => {
        setCustomerCard(e)
    }
    const transactionDateChange = (e) => {
        if (e === null) {
            setTransactionDate(new Date())
        }else{
            setTransactionDate(e)
        }
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Button Event
    const deleteBtnClick = () => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    deleteTransaction().then(() => {
                        setLoading({ isOpen: false })
                    })
                }
            }
        })
    }
    const saveBtnClick = () => {
        setLoading({ isOpen: true })

        updateTransaction().then(() => {
            setLoading({ isOpen: false })
        })
    }

    // Function Api Call
    const getTransaction = async() => {
        await apiGetTransactionById({
            data: {
                transactionId: transactionId
            }
        }).then((res) => {
            if (checkResponse(res)) {
                let data = res.data

                setLocationName(data.locationName)
                // setLocationId(data.locationId)
                setTransactionDate(data.transactionDate)
                setTransactionalDate(data.transactionalDate)
                setTransactionType(String(data.transactionType))
                setTransactionTypeText(TransactionTypeOptions.find(x => x.value === String(data.transactionType)).label)
                setSelectedTransactionalDate({ label: moment(data.transactionalDate).format('DD MMMM YYYY'), value: String(data.dailySessionId) })
                setVehicleBrand(data.vehicleBrand)
                setVehicleBrandId({ label: data.vehicleBrand, value: String(data.vehicleBrandId) })
                setVehicleColor(data.vehicleColor)
                setVehicleColorId({ label: data.vehicleColor, value: String(data.vehicleColorId) })
                setVehicleModel(data.vehicleModel)
                setPlateNumber(data.licensePlateNumber)
                setClockIn(data.clockIn)
                setClockOut(data.clockOut)
                setEmployeeIn(data.employeeName)
                setEmployeeOut(data.employeeNameOut)
                setTarrif(money(data.calculatedTarrif))
                setStatus(data.status)
                setCreateDate(data.createDate)
                setUpdateDate(data.updateDate)
                setUpdateBy(data.updateBy)
            }
            
        })
    }
    const deleteTransaction = async() => {
        await apiDeleteTransaction({
            data:{
                transactionId,
                status
            }
        }).then((res) => {
            if (checkResponse(res)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            onClose()
                        }
                    } 
                })
            }
        })
    }
    const updateTransaction = async() => {
        await apiUpdateTransaction({
            data:{
                transactionId,
                transactionDate: moment(transactionDate).format("YYYY-MM-DD"),
                locationId, 
                transactionType,
                vehicleBrandId: vehicleBrandId.value,
                vehicleModel,
                vehicleColorId: vehicleColorId.value, 
                licensePlateNumber: plateNumber,
                tarrif: tarrif.replaceAll(',', ''),
                calculatedTarrif: tarrif.replaceAll(',', ''),
                transactionStatus: '1',
                paymentStatus: '1',
                paymentOptions: '2',
                dailySessionId: selectedTransactionalDate.value
            }
        }).then((res) => {
            if (checkResponse(res)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            onClose()
                        }
                    } 
                })
            }
        })
    }
    const getVehicleBrandList = async() => {
        await apiGetVehicleBrand({
            data: {
                vehicleBrandName: '',
                status: StatusCodeActive,
                pageSize: 20,
                pageIndex: 0
            }
        }).then((response) => {
            if (checkResponse(response)) {
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].vehicleBrandName.toUpperCase(), value: String(data[i].vehicleBrandId) })
                    }

                    setVehicleBrandOptions(tempArray)
                }
            }
        })
    }
    const getVehicleColorList = async() => {
        await apiGetVehicleColor({
            data: {
                vehicleColor: '',
                status: status,
                pageSize: 100,
                pageIndex: 0
            }
        }).then((response) => {
            if (checkResponse(response)) {
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].vehicleColor.toUpperCase(), value: String(data[i].vehicleColorId) })
                    }

                    setVehicleColorOptions(tempArray)
                }
            }
        })
    }
    const getDailySession = async() => {
        await apiGetDailySession({
            data: {
                transactionalDate: new Date(),
                sessionStatus: '1',
                pageSize: 10,
                locationId: String(locationId)
            }
        }).then((response) => {
            if (checkResponse(response)) {
                if (response.data.length > 0){
                    let data = response.data
                    setEdcData(data)
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: moment(data[i].transactionalDate).format("DD MMMM YYYY"), value: String(data[i].dailySessionId) })
                    }

                    setTransactionalDateOptions(tempArray)
                }
            }
        })
    }

    const checkResponse = (res) => {
        if(res.status === ApiResponseSuccess){
            return true
        }else if(res.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                        window.location.href = "/login"
                    }
                },
                message: res.message
            })
            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: res.message
            })
            return false
        }
    }

    useEffect(() => {
        setLoading({ isOpen: true })
        
        getTransaction().then(() => {
            setLoading({ isOpen: false })
        })
    }, [])

    useEffect(() => {
        setLoading({ isOpen: true })
        
        if (currentFormType === FormTypeEdit){
            getDailySession().then((res) => {
                getVehicleBrandList().then(() => {
                    getVehicleColorList().then(() => {
                        setLoading({ isOpen: false })
                    })
                })
            })
        } else {
            setLoading({ isOpen: false })
        }
    }, [currentFormType])

    return (
        <div className="fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center z-40 rounded-lg">
            <div className='z-50 bg-white w-full h-full xl:h-auto xl:w-3/4 2xl:w-1/2 overflow-y-auto shadow-lg rounded-lg p-4 sm:p-8'>
                <div>
                    <div className="flex justify-between">
                        <span className="font-semibold text-2xl">Sales Detail</span>
                        <div className={`gap-2 items-end justify-end hidden sm:flex`}>
                            <span className="text-sm opacity-60">
                                Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                            </span>
                        </div>
                    </div>
                </div>
                <hr />

                <div className="mt-5 flex flex-col gap-3">
                    {/* Lokasi */}
                    <Card title='Lokasi'>
                        <span>{locationName}</span>
                    </Card>

                    {/* Tanggal Pembukuan */}
                    <Card title='Tanggal Pembukuan'>
                        {currentFormType === FormTypeView ? 
                            (<span>{moment(transactionalDate).format("DD MMMM YYYY")}</span>) : 
                            (<Select options={transactionalDateOptions} value={selectedTransactionalDate} 
                                onChange={(e) => {setSelectedTransactionalDate(e)}} />
                        )}
                    </Card>

                    {/* Tanggal Transaksi */}
                    <Card title='Tanggal Transaksi'>
                        {currentFormType === FormTypeView ? (<span>{moment(transactionDate).format("DD MMMM YYYY")}</span>) : (<DatePicker className="w-full h-10 bg-white" value={transactionDate} onChange={transactionDateChange} />)}
                    </Card>

                    {/* Merek Mobil */}
                    <Card title='Vehicle Brand'>
                        {currentFormType === FormTypeView ? 
                        (<span>{vehicleBrand}</span>) : 
                        (<Select options={vehicleBrandOptions} value={vehicleBrandId} onChange={(e) => { setVehicleBrandId(e) }} />)}
                    </Card>

                    {/* Warna */}
                    <Card title='Warna'>
                        {currentFormType === FormTypeView ? (
                            <span>{vehicleColor}</span>
                        ) : (
                            <Select options={vehicleColorOptions} value={vehicleColorId} onChange={(e) => { setVehicleColorId(e) }} />
                        )}
                    </Card>

                    {/* Vehicle Model */}
                    <Card title='Tipe Mobil'>
                        {currentFormType === FormTypeView ? (
                            <span>{vehicleModel}</span>
                        ) : (
                            <input className="input" value={vehicleModel} onChange={(e) => { setVehicleModel(e.target.value) }} />
                        )}  
                    </Card>

                    {/* License Plate */}
                    <Card title='Plat Nomor'>
                        {currentFormType === FormTypeView ? (
                            <span>{plateNumber}</span>
                        ) : (
                            <input className="input" value={plateNumber} onChange={(e) => { setPlateNumber(e.target.value) }} />
                        )}    
                    </Card>

                    {/* Transaction Type */}
                    <Card title='Transaction Type'>
                        {currentFormType === FormTypeView ? (
                            <span>{transactionTypeText}</span>
                        ) : (
                            <Dropdown value={transactionType} options={TransactionTypeOptions} onChange={(e) => { setTransactionType(e.value) }} />
                        )}  
                    </Card>

                    {/* Attendant */}
                    <div className={`${currentFormType === FormTypeEdit ? 'py-1' : ''}`}>
                        <Card title='Attendant'>
                            {employeeIn} - {employeeOut}
                        </Card>
                    </div>
                    
                    {/* Waktu Masuk - Keluar */}
                    <div className={`${currentFormType === FormTypeEdit ? 'py-1' : ''}`}>
                        <Card title='Waktu Masuk - Keluar'>
                            {moment(clockIn).format("HH:mm")} - {moment(clockOut).format("HH:mm")}
                        </Card>
                    </div>
                    
                    {/* Tariff */}
                    <Card title='Tarif'>
                        {currentFormType === FormTypeView ? (
                            <span>Rp {money(tarrif)}</span>
                        ) : (
                            <input className="input" value={tarrif} onChange={(e) => { setTarrif(money(e.target.value)) }} />
                        )}   
                    </Card>
                </div>
                    
                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    { currentFormType === FormTypeView ? 
                        (<button
                            className="bg-black hover:bg-gray-600 text-white py-2 px-4 rounded-md"
                            onClick={() => { setCurrentFormType(FormTypeEdit) }}
                        >
                            <span>Edit</span>
                        </button>) 
                    : 
                        (
                        <div className="flex gap-2">
                            <button
                                className="bg-black hover:bg-gray-600 text-white py-2 px-4 rounded-md"
                                onClick={() => { setCurrentFormType(FormTypeView) }}
                            >
                                <span>View</span>
                            </button>
                            <SaveButton onClick={saveBtnClick} visible={true} />
                        </div>
                        
                        ) 
                    
                    }
                    <DeleteButton  
                        visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } 
                        onClick={deleteBtnClick}
                    />
                    <UnDeleteButton  visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                    <button
                        className="bg-black hover:bg-gray-600 text-white py-2 px-4 rounded-md"
                        onClick={() => { onClose() }}
                    >
                        <span>Close</span>
                    </button>
                </div>
                
                {/* Modal */}
                {failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
                {loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
                {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
                {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
            </div>

            <div className="fixed top-0 bottom-0 left-0 right-0 bg-app-matte-black opacity-60 z-30" />
        </div>
    )
}

const Card = ({title, children}) => {
    return (
        <div className="flex">
            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                <div className="w-48">
                    <span>{title}</span>
                </div>
                <div className="px-4 hidden sm:block">
                    <span>:</span>  
                </div>
                <div className="w-full sm:w-72">
                    {children}  
                </div>
            </div>
        </div>
    )
}